import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/carouselMarcas.css'; // Importa el archivo CSS
import clienteAxios from '../../helpers/axios.helper';

function CarouselMarcas() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true); // Para manejar el estado de carga
  const [erroraso, setError] = useState(null); // Para manejar errores

  useEffect(() => {
    const fetchMarcas = async () => {
      try {
        const response = await clienteAxios.get('/marcas');
        setItems(response.data);
      } catch (err) {
        if (err.response) {
          // Error de respuesta (por ejemplo, código de estado 500)
          setError('Error al cargar las marcas. Inténtalo más tarde.');
        } else if (err.request) {
          // Error de solicitud (por ejemplo, si no hay respuesta)
          setError('Error de red. Verifica tu conexión.');
        } else {
          // Otro tipo de error
          setError('Ocurrió un error desconocido.');
        }
      } finally {
        setLoading(false);
      }
    };
  
    fetchMarcas();
  }, []);
  

  return (
    <div className='carousel-container mb-5'>
      {loading ? (
        <p className="text-center text-gray-500">Cargando marcas...</p>
      ) : (
        <div className='carousel'>
  {items.concat(items).map((item, index) => (
    <div
      key={index}
      className='carousel-item flex justify-center items-center' // Centrado usando flexbox
    >
      <img
        src={item.imagen}
        alt={`Marca Logo ${index + 1}`}
        className='carousel-image'
      />
    </div>
  ))}
</div>
      )}
    </div>
  );
}

export default CarouselMarcas;
